export default __webpack_public_path__ + "static/media/loading.8d98ac17.gif";